module.exports = __webpack_public_path__ + "img/link.fb1e8568.svg";